export default {
  state: {
    gozoCabs: {
      enabled: false,
      quoteId: '',
      pickupTimeSet: false,
      leg1Depart: false,
      leg1Arrive: false,
      leg2Depart: false,
      leg2Arrive: false
    }
  },
  mutations: {
    setGozoCabsData (state, data) {
      for (let field in data) {
        state.gozoCabs[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/gozocabs.js